// column
export { default as ActionColumn } from '../lib/Grid/column/ActionColumn.js';
export { default as AggregateColumn } from '../lib/Grid/column/AggregateColumn.js';
export { default as CheckColumn } from '../lib/Grid/column/CheckColumn.js';
export { default as ColorColumn } from '../lib/Grid/column/ColorColumn.js';
export { default as Column } from '../lib/Grid/column/Column.js';
export { default as DateColumn } from '../lib/Grid/column/DateColumn.js';
export { default as NumberColumn } from '../lib/Grid/column/NumberColumn.js';
export { default as PercentColumn } from '../lib/Grid/column/PercentColumn.js';
export { default as RatingColumn } from '../lib/Grid/column/RatingColumn.js';
export { default as RowNumberColumn } from '../lib/Grid/column/RowNumberColumn.js';
export { default as TemplateColumn } from '../lib/Grid/column/TemplateColumn.js';
export { default as TimeColumn } from '../lib/Grid/column/TimeColumn.js';
export { default as TreeColumn } from '../lib/Grid/column/TreeColumn.js';
export { default as WidgetColumn } from '../lib/Grid/column/WidgetColumn.js';
// data
export { default as ColumnStore } from '../lib/Grid/data/ColumnStore.js';
export { default as GridRowModel } from '../lib/Grid/data/GridRowModel.js';
// feature
export { default as CellCopyPaste } from '../lib/Grid/feature/CellCopyPaste.js';
export { default as CellEdit } from '../lib/Grid/feature/CellEdit.js';
export { default as CellMenu } from '../lib/Grid/feature/CellMenu.js';
export { default as CellTooltip } from '../lib/Grid/feature/CellTooltip.js';
export { default as ColumnAutoWidth } from '../lib/Grid/feature/ColumnAutoWidth.js';
export { default as ColumnDragToolbar } from '../lib/Grid/feature/ColumnDragToolbar.js';
export { default as ColumnPicker } from '../lib/Grid/feature/ColumnPicker.js';
export { default as ColumnRename } from '../lib/Grid/feature/ColumnRename.js';
export { default as ColumnReorder } from '../lib/Grid/feature/ColumnReorder.js';
export { default as ColumnResize } from '../lib/Grid/feature/ColumnResize.js';
export { default as FillHandle } from '../lib/Grid/feature/FillHandle.js';
export { default as Filter } from '../lib/Grid/feature/Filter.js';
export { default as FilterBar } from '../lib/Grid/feature/FilterBar.js';
export { default as GridFeatureManager } from '../lib/Grid/feature/GridFeatureManager.js';
export { default as Group } from '../lib/Grid/feature/Group.js';
export { default as GroupSummary } from '../lib/Grid/feature/GroupSummary.js';
export { default as HeaderMenu } from '../lib/Grid/feature/HeaderMenu.js';
export { default as MergeCells } from '../lib/Grid/feature/MergeCells.js';
export { default as QuickFind } from '../lib/Grid/feature/QuickFind.js';
export { default as RegionResize } from '../lib/Grid/feature/RegionResize.js';
export { default as RowCopyPaste } from '../lib/Grid/feature/RowCopyPaste.js';
export { default as RowExpander } from '../lib/Grid/feature/RowExpander.js';
export { default as RowReorder } from '../lib/Grid/feature/RowReorder.js';
export { default as RowResize } from '../lib/Grid/feature/RowResize.js';
export { default as Search } from '../lib/Grid/feature/Search.js';
export { default as Sort } from '../lib/Grid/feature/Sort.js';
export { default as StickyCells } from '../lib/Grid/feature/StickyCells.js';
export { default as Stripe } from '../lib/Grid/feature/Stripe.js';
export { default as Split } from '../lib/Grid/feature/Split.js';
export { default as Summary } from '../lib/Grid/feature/Summary.js';
export { default as Tree } from '../lib/Grid/feature/Tree.js';
export { default as TreeGroup } from '../lib/Grid/feature/TreeGroup.js';
// feature base
export { default as CopyPasteBase } from '../lib/Grid/feature/base/CopyPasteBase.js';
// export feature
export { default as ExportDialog } from '../lib/Grid/view/export/ExportDialog.js';
export { default as Exporter } from '../lib/Grid/feature/export/exporter/Exporter.js';
export { default as ExportOrientationCombo } from '../lib/Grid/view/export/field/ExportOrientationCombo.js';
export { default as ExportRowsCombo } from '../lib/Grid/view/export/field/ExportRowsCombo.js';
export { default as MultiPageExporter } from '../lib/Grid/feature/export/exporter/MultiPageExporter.js';
export { default as MultiPageVerticalExporter } from '../lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js';
export { default as PdfExport } from '../lib/Grid/feature/export/PdfExport.js';
export { default as Print } from '../lib/Grid/feature/export/Print.js';
export { default as PrintMixin } from '../lib/Grid/feature/export/mixin/PrintMixin.js';
export { default as SinglePageExporter } from '../lib/Grid/feature/export/exporter/SinglePageExporter.js';
export { FileFormat, Orientation, PaperFormat, RowsRange } from '../lib/Grid/feature/export/Utils.js';
// feature experimental
export { default as ExcelExporter } from '../lib/Grid/feature/experimental/ExcelExporter.js';
export { default as FileDrop } from '../lib/Grid/feature/experimental/FileDrop.js';
// row
export { default as Row } from '../lib/Grid/row/Row.js';
// util
export { default as Location } from '../lib/Grid/util/Location.js';
export { default as TableExporter } from '../lib/Grid/util/TableExporter.js';
// view
export { default as Bar } from '../lib/Grid/view/Bar.js';
export { default as Footer } from '../lib/Grid/view/Footer.js';
export { default as Grid } from '../lib/Grid/view/Grid.js';
export { default as GridBase } from '../lib/Grid/view/GridBase.js';
export { default as Header } from '../lib/Grid/view/Header.js';
export { default as RowManager } from '../lib/Grid/row/RowManager.js';
export { default as SubGrid } from '../lib/Grid/view/SubGrid.js';
export { default as TreeGrid } from '../lib/Grid/view/TreeGrid.js';
// view mixin
export { default as GridElementEvents } from '../lib/Grid/view/mixin/GridElementEvents.js';
export { default as GridFeatures } from '../lib/Grid/view/mixin/GridFeatures.js';
export { default as GridResponsive } from '../lib/Grid/view/mixin/GridResponsive.js';
export { default as GridSelection } from '../lib/Grid/view/mixin/GridSelection.js';
export { default as GridState } from '../lib/Grid/view/mixin/GridState.js';
export { default as GridSubGrids } from '../lib/Grid/view/mixin/GridSubGrids.js';
// widget
export { default as GridFieldFilterPicker } from '../lib/Grid/widget/GridFieldFilterPicker.js';
export { default as GridFieldFilterPickerGroup } from '../lib/Grid/widget/GridFieldFilterPickerGroup.js';
export { default as GroupBar } from '../lib/Grid/widget/GroupBar.js';
export { default as TreeCombo } from '../lib/Grid/widget/TreeCombo.js';


import GlobalEvents from '../lib/Core/GlobalEvents.js';
import BrowserHelper from '../lib/Core/helper/BrowserHelper.js';
import VersionHelper from '../lib/Core/helper/VersionHelper.js';
import Widget from '../lib/Core/widget/Widget.js';
import Toast from '../lib/Core/widget/Toast.js';
import Override from '../lib/Core/mixin/Override.js';
import DomHelper from '../lib/Core/helper/DomHelper.js';
import GridBase from '../lib/Grid/view/GridBase.js';
import RowManager from '../lib/Grid/row/RowManager.js';
(() => {
    //region Common
    const
        HOSTS            = [
            'bryntum.com',
            'cdpn.io',
            'react-gantt.com',
            'vue-gantt.com',
            'vue-scheduler.com',
            'react-scheduler.com',
            'angular-scheduler.com',
            'angular-calendar.com',
            'vue-calendar.com',
            'react-calendar.com',
            'lmctfy.net'
        ],
        ONE_DAY          = 1000 * 60 * 60 * 24,
        EXPIRING_CLASSES = [];
    if (!VersionHelper.isTestEnv && (HOSTS.some(host => location.host.includes(host)) || /\/docs/.test(location.href))) {
        return;
    }
    let initialized;
    function initExpiryHelper(owner, baseClass) {
        if (!initialized) {
            initialized = true;
            ExpiryHelper.construct({
                widget : owner
            });
        }
        // do not remove this line (used to distinguish trial bundles by regexp)
        owner.__foo = 'THISISTRIAL';
    }
    //endregion
    //region ExpiryHelper
    class ExpiryHelper {
        static construct(config) {
            const
                me            = this,
                product       = 'gantt',
                productName   = 'Gantt',
                version       = VersionHelper.getVersion(product),
                callHomeDelay = VersionHelper.isTestEnv ? 3000 : 1000 * 60,
                blockUrl      = BrowserHelper.queryString.blockUrl;
            Object.assign(me, {
                version,
                product,
                Product          : productName,
                verifyUrl        : VersionHelper.isTestEnv ? blockUrl : 'https://bryntum.com/verify/',
                blocked          : false,
                lastVersionCheck : 0,
                trialKey         : `b-${product}-trial-start`,
                versionCheckKey  : `b-${product}-verify-date`
            }, config);
            if (!VersionHelper.isTestEnv) {
                console.log(`Bryntum ${productName} Trial Version`);
            }
            me.cacheTrialStartTime();
            if (me.isExpired) {
                if (document.readyState === 'complete') {
                    me.onTrialExpired();
                }
                else {
                    document.addEventListener('readystatechange', () => {
                        if (document.readyState === 'complete') {
                            me.onTrialExpired();
                        }
                    });
                }
            }
            // Call home to log trial usage, assuming localStorage access works reliably
            // 1 min delay to be less easily detected
            setTimeout(() => {
                me.updateBlockedStatus();
            }, callHomeDelay);
        }
        static cacheTrialStartTime() {
            const
                me         = this,
                timeString = BrowserHelper.getLocalStorageItem(me.trialKey),
                time       = Number(timeString);
            if (time && !isNaN(time)) {
                me.trialStartTime = time;
            }
            me.trialStartTime = me.trialStartTime || Date.now();
            // First trial access, or no localstorage (no local storage meaning our expiration mechanism won't work. Only remote blocking will end the trial)
            BrowserHelper.setLocalStorageItem(me.trialKey, me.trialStartTime);
        }
        static get isExpired() {
            return this.blocked || (Date.now() - this.trialStartTime > ONE_DAY * 45) || window.bryntum?.[this.product]?.expired;
        }
        static updateBlockedStatus() {
            const
                me                  = this,
                saveVersionCheckKey = () => BrowserHelper.setLocalStorageItem(me.versionCheckKey, Date.now());
            me.lastVersionCheck = me.lastVersionCheck || BrowserHelper.getLocalStorageItem(me.versionCheckKey) || 0;
            // Max 1 version check per session / day
            if (me.lastVersionCheck && Date.now() - me.lastVersionCheck < ONE_DAY) {
                return;
            }
            if (me.verifyUrl) {
                const
                    url    = encodeURIComponent(location.href),
                    logUrl = `${me.verifyUrl}?id=${window.bryntum.license}&url=${url}`,
                    img    = new Image();
                img.onload = () => {
                    // 2x2 image means trial is blocked due to violation
                    if (img.naturalWidth === 2) {
                        me.blockTrial();
                    }
                    else {
                        // Just in case
                        saveVersionCheckKey();
                    }
                };
                img.onerror = () => {
                    saveVersionCheckKey();
                };
                img.src = logUrl;
            }
            else {
                saveVersionCheckKey();
            }
        }
        static onTrialExpired() {
            const rootEl = this.widget.rootElement;
            if (!this.expirationShown) {
                this.expirationShown = true;
                if (!VersionHelper.isTestEnv) {
                    console.warn(`Bryntum ${this.Product} trial version expired. Purchase a license at https://bryntum.com/store or contact us at https://bryntum.com/contact/ for licensing options.`);
                }
                rootEl.floatRoot && Toast.show({
                    html        : `Psst! Your Bryntum ${this.Product} trial has expired. Please see <a href="https://bryntum.com/store">our store</a> for licensing options`,
                    timeout     : 20000,
                    rootElement : rootEl
                });
            }
            DomHelper.removeEachSelector(rootEl, '.b-sch-dependency');
            DomHelper.forEachSelector(rootEl, '.b-container', element => {
                const widget = Widget.fromElement(element, 'widget');
                if (EXPIRING_CLASSES.some(cls => widget instanceof cls)) {
                    this.maskExpiredWidget(widget);
                }
            });
        }
        static blockTrial() {
            this.blocked = true;
            // Get rid of version check timestamp
            BrowserHelper.removeLocalStorageItem(this.versionCheckKey);
            // To force expired state: Set a fake early trial timestamp
            BrowserHelper.setLocalStorageItem(this.trialKey, 1);
            this.onTrialExpired();
        }
        static maskExpiredWidget(widget) {
            widget.mask({
                text  : '<h3 style="margin:0">Trial expired, <a href="https://bryntum.com/store" style="margin:0 3px; color:inherit">click here</a> to buy a license.</h3>',
                icon  : 'b-fa b-fa-frown',
                type  : 'trial',
                cover : 'target'
            });
        }
        static setWaterMark(element, {
            darkColor = 'rgba(255, 255, 255, 0.03)',
            lightColor = 'rgba(240, 240, 240, 0.54)'
        } = {}) {
            // Used for thumbnails
            if (BrowserHelper.queryString.thumb != null) {
                return;
            }
            const
                color     = DomHelper.themeInfo?.name?.toLowerCase().endsWith('-dark') ? darkColor : lightColor,
                svgString = `
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" style="font-family:sans-serif;font-weight:900;fill:${color}">
                    <defs>
                        <pattern id="company" patternUnits="userSpaceOnUse" width="400" height="200">
                            <text y="30" font-size="40" id="name">Bryntum</text>
                            <text y="120" x="200" font-size="24" id="trial">Trial Version</text>
                        </pattern>
                        <pattern id="pattern" xlink:href="#company" patternTransform="rotate(-45)">
                            <use xlink:href="#name" /><use xlink:href="#trial" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#pattern)" />
                </svg>`;
            element.style.backgroundImage = `url('data:image/svg+xml;base64,${window.btoa(svgString)}')`;
        };
    }
    //endregion
    //region Common override
    const applyBaseOverride = baseClass => {
        EXPIRING_CLASSES.push(baseClass);
        Override.apply(class {
            static get target() {
                return {
                    class : baseClass
                };
            }
            onPaintOverride() {
                const
                    me            = this,
                    setWatermarks = () => {
                        const targets = me.subGrids ? Object.values(me.subGrids) : [me];
                        for (const target of targets) {
                            if (target.element) {
                                ExpiryHelper.setWaterMark(target.element);
                            }
                        }
                    };
                initExpiryHelper(me, baseClass);
                setWatermarks();
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    setWatermarks();
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(me);
                }
            }
        });
    };
    //endregion
    if (typeof GridBase !== 'undefined') {
        applyBaseOverride(GridBase);
        Override.apply(class {
            static get target() {
                return {
                    class : RowManager
                };
            }
            matchRowCount() {
                if (!ExpiryHelper.isExpired || this.grid?.isScheduler) {
                    this._overridden.matchRowCount.apply(this, arguments);
                }
            }
            renderRows() {
                if (!ExpiryHelper.isExpired || this.grid?.isScheduler) {
                    this._overridden.renderRows.apply(this, arguments);
                }
            }
            renderFromRow() {
                if (!ExpiryHelper.isExpired || this.grid?.isScheduler) {
                    this._overridden.renderFromRow.apply(this, arguments);
                }
            }
        });
    }
})();
(() => {
    // do not load analytics code for specific domains
    const ignoreDomainRe = /(.force.com|.lightning.com|.salesforce.com|lmctfy.net|qa.bryntum.com|qa2.bryntum.com)/;
    // document location might be null in firefox in salesforce
    if (!document.location || ignoreDomainRe.test(document.location.href) || window.top !== window) {
        return;
    }
    let id;
    const websiteUrls = [
        'bryntum.com',
        'cdpn.io'
    ];
    const
        products   = ['calendar', 'grid', 'gantt', 'scheduler', 'schedulerpro', 'taskboard'],
        frameworks = ['angular', 'react', 'vue', 'ionic'];
    websiteUrls.splice(0, 0, ...products.map(prod => frameworks.map(framework => `${framework}-${prod}`)).concat('bryntum.com').flat());
    if (document.location.host.match(websiteUrls.join('|'))) {
        id = 'G-1VY6776VJP';
    }
    else {
        id = 'G-H465KZDH8S';
    }
    const newScript = document.createElement('script');
    newScript.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    };
    document.head.appendChild(newScript);
    newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
})();
